import { fetchCustomerReviewSummary } from 'actions/ReviewActions'
import type { ReviewSummaryType } from 'api/review'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect } from 'react'

type ReturnType = [
  App.ReviewSummary | undefined,
  boolean,
  any | undefined,
]

interface Options {
  enabled?: boolean
  includeTranslations?: boolean
  summaryType?: ReviewSummaryType
  maxCharacters?: number
}

function useUserReviewsSummary(
  propertyId: string | undefined,
  propertyProvider: 'bedbank' | 'luxuryescapes',
  options: Options = {},
): ReturnType {
  const {
    enabled = true,
    includeTranslations = true,
    summaryType,
    maxCharacters,
  } = options
  const dispatch = useAppDispatch()
  const acceptLanguage = useAppSelector((state) => state.geo.locale)

  const key = getObjectKey({ propertyId, propertyProvider, summaryType, includeTranslations, acceptLanguage, maxCharacters })
  const summary = useAppSelector((state) => state.review.reviewSummaries[key])

  useEffect(() => {
    if (enabled && propertyId) {
      dispatch(fetchCustomerReviewSummary(propertyId, propertyProvider, summaryType, includeTranslations, maxCharacters))
    }
  }, [dispatch, enabled, propertyId, propertyProvider, summaryType, includeTranslations, acceptLanguage, maxCharacters])

  return [
    summary?.summary,
    summary?.fetching ?? (enabled && !!propertyId),
    summary?.error,
  ]
}

export default useUserReviewsSummary
